import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgInformationCircleFilled32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" fillRule="evenodd" d="M16 27C9.92 27 5 22.08 5 16S9.92 5 16 5s11 4.92 11 11-4.92 11-11 11m0-21C10.48 6 6 10.48 6 16s4.48 10 10 10 10-4.48 10-10S21.52 6 16 6m0 16c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1m0-10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1" clipRule="evenodd" /></SvgIcon>;
};
const Memo = memo(SvgInformationCircleFilled32);
export default Memo;